<template>
    <div>
        <div class="row justify-content-center">
            <div class="col-10">
                <div class="text-left section-title" style="padding: 5px;">
                    <span class="row-table-font-margins" style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center'>Message</span>
                </div>
            </div>

        </div>

        <div class="row" style="padding-left: 15px; padding-right: 15px;">
            <div class="col-6 offset-3">
                <div class="container form-background">
                    <div class="row">
                        <div class=" col-12 text-left form-title">
                            <span class="row-table-font-margins">{{formTitle}} for unit {{propertyName}}</span>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <label>Subject: *</label>
                            <input type="text" placeholder="Subject" class="form-control" v-model="subject" />
                            <div v-if="submitted && !subject" class="invalid-feedback d-block">Subject is required</div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Participants:</label>
                                <VueMultiselect :multiple="true" :close-on-select="false" label="name" track-by="id" v-model="participantsModel" :options="participants" placeholder="Select Participant"></VueMultiselect>
                                <div v-if="submitted && !selectedParticipants" class="invalid-feedback d-block">Participant is required</div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Message:</label>
                                <textarea type="text" row="3" class="form-control" v-model="messageText"></textarea>
                                <div v-if="submitted && !messageText" class="invalid-feedback d-block">Type your message</div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="text-right">
                    <button type="submit" @click.prevent="saveNewMessage()" class="btn btn-submit" style="margin: 15px;">
                        Submit
                    </button>
                    <button @click="cancel()" class="btn btn-cancel">Cancel</button>
                </div>
            </div>

        </div>
        
    </div>
</template>

<script>
     import { authenticationService } from '@/_services';
import VueMultiselect from 'vue-multiselect';
    export default {
        components: { VueMultiselect },
        data: function () {

            return {
                currentUser:null,
                submitted:false,
                subject:"",
                messageText: "",
                selectedParticipants: [],
                 participants:[],
                username: "",
                avatar: "",
                uid: "",
                sendingMessage: false,
                chatMessage: "",
                loggingOut: false,
                groupMessages: [],
                loadingMessages: false,
                threadId: 0,
                message: {},
                buildingId:0,
                buildingName:'',
                 fields : { text: 'name', value: 'id' }
            }
        },
        mounted() {
            this.propertyName = this.$route.params.propertyName;
            this.propertyId = this.$route.params.propertyId;
            this.formTitle = 'Send Message';
            this.getBuilding();
            

        },
         created() {
            authenticationService.currentUser.subscribe(x => this.currentUser = x);
        },
        computed: {
            participantsModel: {
                get() {
                    return this.participants.filter(p => this.selectedParticipants.includes(p.id))
                },
                set(value) {
                    this.selectedParticipants = value.map(p => p.id)
                }
            }
        },
        methods: {
            cancel(){
                this.$router.push({name:'messagesowner',params:{propertyId: this.propertyId, propertyName:this.propertyName}})
            },
            getBuilding(){
                this.mute = true;
                    //this.buildingId = 3;
                    var request = '/properties/'+this.propertyId
                    this.$http.get(request, {
                        id : this.propertyId
                    }).then(({data}) => {
                        this.mute = false;
                        console.log(data.buildingId)
                                //this.contacts = data.contacts;
                            this.buildingId = data.buildingId;
                            this.buildingName = data.buildingName;
                            this.getParticipants();
    
                });
            },
            getParticipants() {
                 this.mute = true;
                    //this.buildingId = 3;
                    var request = '/messages/users?userId='+this.currentUser.id+'&buildingId='+this.buildingId
                    this.$http.get(request, {
                        id : this.buildingId
                    }).then(({data}) => {
                        this.mute = false;
                      //  console.log(data)
                                //this.contacts = data.contacts;
                            this.participants = data;
    
                });
            },
           
            sendMessage(text) {
                if (text.length > 0) {
                    this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + 1
                    this.onMessageWasSent({ author: 'support', type: 'text', data: { text } })
                }
            },
            onMessageWasSent(message) {
                // called when the user sends a message
                this.messageList = [...this.messageList, message]
            },
            openChat() {
                // called when the user clicks on the fab button to open the chat
                this.isChatOpen = true
                this.newMessagesCount = 0
            },
            closeChat() {
                // called when the user clicks on the botton to close the chat
                this.isChatOpen = false
            },
            handleScrollToTop() {
                // called when the user scrolls message list to top
                // leverage pagination for loading another page of messages
            },
            handleOnType() {
                console.log('Emit typing event')
            },
            editMessage(message) {
                const m = this.messageList.find(m => m.id === message.id);
                m.isEdited = true;
                m.data.text = message.data.text;
            },

            scrollToBottom() {
                const chat = document.getElementById("msg-page");
                chat.scrollTo(0, chat.scrollHeight + 30);
            },

            saveNewMessage() {
                this.sendingMessage = true;
                this.submitted = true;
                var canSubmit = this.subject.length > 0 &&  this.messageText.length > 0 && this.selectedParticipants.length > 0 

                if(canSubmit)
                    this.$http.post('/messages/thread', {
                    subject:this.subject,
                        userId: this.currentUser.id,
                        messageText: this.messageText,
                        participants: this.selectedParticipants,
                        buildingId:this.buildingId

                        //   contact:this.contact
                    }).then(() => {
                        this.$router.push({name:'messagesowner',params:{propertyId: this.propertyId}})
                    
                    }, (error) => {
                        console.log("Message sending failed with error:", error);
                        //  this.infoError = true
                        //  this.loader = false
                        //   this.password = ''
                    })
            }
        },
        // Our Javascript logic
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
